import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TariffServicesComponent } from './tariff-services.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    TariffServicesComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ]
})
export class TariffServicesModule { }
